// extracted by mini-css-extract-plugin
export var colorSquare = "_qs-0";
export var danger = "_qs-5";
export var lightPink = "_qs-8";
export var neutralBlue = "_qs-7";
export var neutralYellow = "_qs-6";
export var normal = "_qs-1";
export var primary = "_qs-2";
export var primaryLight = "_qs-3";
export var solidBlack = "_qs-g";
export var solidGreen = "_qs-b";
export var solidLightBlue = "_qs-d";
export var solidNavy = "_qs-c";
export var solidOrange = "_qs-f";
export var solidPink = "_qs-e";
export var solidRed = "_qs-9";
export var solidYellow = "_qs-a";
export var success = "_qs-4";